"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AnalyticsSimpleIcon = function AnalyticsSimpleIcon(props) {
  return _react.default.createElement(_Icon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), _react.default.createElement("path", {
    d: "M.1.06v23.9H24v-2.7H2.6V.06H.1zm20.2 19.4h3.5V3.76h-3.5v15.7zm-10.7 0h3.5V5.56H9.6v13.9zm5.2 0h3.5V8.96h-3.5v10.5zm-10.5 0h3.5v-7H4.3v7z"
  }));
};

var _default = AnalyticsSimpleIcon;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/icons/AnalyticsSimpleIcon.js